import React, { useEffect, useMemo, useState } from 'react';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import clsx from 'clsx';
import Head from 'next/head';
import { useEffectEvent } from 'react';
import { SIMULATION_TITLES } from '../../model/simulation-steps';

export function Stepper() {
  const [lastIndex, setLastIndex] = useState(1);

  const { hideStepper, simulationStep, simulationType, title, setTitle } =
    useSimuladorEnergiaSolarState();

  const slots = useMemo(
    () => Array.from({ length: simulationType === 'new' ? 4 : 3 }, (_, i) => i + 1),
    [simulationType],
  );

  const modifiedSimulationStep = useMemo(() => {
    if (simulationType === 'existing' && simulationStep?.index && simulationStep.index > 2) {
      return {
        ...simulationStep,
        index: simulationStep.index - 1,
      };
    }

    return simulationStep;
  }, [simulationStep, simulationType]);

  useEffect(() => {
    if (simulationStep?.index) {
      setLastIndex(simulationStep.index);
      const t = SIMULATION_TITLES[`ETAPA_${simulationStep.index}`];
      if (t) {
        setTitle(t);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simulationStep?.index]);

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      {!hideStepper && (
        <ContainerHome24 id="simulation-stepper">
          <div className="stepper">
            <h3 className="step-title">
              {modifiedSimulationStep?.index}.&nbsp;{modifiedSimulationStep?.title}
            </h3>
            <div className="stepper-bars">
              {slots.map((tab) => {
                const isActive = tab <= (modifiedSimulationStep?.index || 0);
                return <span key={tab} className={clsx('step', isActive && 'active')} />;
              })}
            </div>
            <p className="step-label">
              Passo {modifiedSimulationStep?.index} de {slots.length}
            </p>
          </div>
        </ContainerHome24>
      )}
    </>
  );
}
